import React, { Component } from 'react';
import { Form, Button } from 'semantic-ui-react';
import './styles.scss';
import {
    Link
} from "react-router-dom";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';

import CONSTANT from '../../core/constant/constant';

class ProjectForm extends Component {
    constructor() {
        super();
        this.state = {
            errInputMsg: {},
            file: null,
            errImportMsg: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError,
            file: nextProps.importFile,
            errImportMsg: nextProps.isImportError
        });
    }

    handleChangeInput = (evt) => {
        this.props.changeProject(evt);
    }

    // link click
    linkClick = () => {
        window.open(CONSTANT.apiUrl + 'project/projectDownloadStandardFile');
    }

    // import file
    fileInputRef = React.createRef();
    onFileChange = (e) => {
        return this.props.handleChangeFileInput(e);
    }

    render() {
        const { projectData, projectTypeData, t } = this.props;
        const { file } = this.state;
        let fileName = file ? file.name : t('labels.fileText');
        return (
            <div className="employee-form">
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.projectCode')}</label>
                        <Form.Input name="projectCode" maxLength="12"
                            value={projectData.projectCode}
                            onChange={e => { this.handleChangeInput(e) }}
                        />
                        <Form.Field>
                            <input id="active-project" type="checkbox" name="active" className="invisible"
                                value={projectData.active}
                                checked={projectData.active === true ? true : false}
                                onChange={e => { this.handleChangeInput(e) }} />
                            <label htmlFor="active-project" className="checkbox-label">{t('labels.activeProject')}</label>
                        </Form.Field>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['projectCode'])}</div>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.projectName')}</label>
                        <Form.Input name="projectName" maxLength="100"
                            value={projectData.projectName}
                            onChange={e => { this.handleChangeInput(e) }}
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['projectName'])}</div>
                    <Form.Group inline>
                        <label>{t('labels.aliasName')}</label>
                        <Form.Input name="aliasName" maxLength="50"
                            value={projectData.aliasName}
                            onChange={e => { this.handleChangeInput(e) }}
                        />
                    </Form.Group>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.projectType')}</label>
                        <select name="projectTypeId"
                            value={projectData.projectTypeId}
                            onChange={e => { this.handleChangeInput(e) }}>
                            <option value="">All</option>
                            {(projectTypeData)
                                ? projectTypeData.map((option, index) => {
                                    return (
                                        <option value={option.id} key={index}>{option.projectTypeName}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                        <label className="new-label">
                            <Link to="/project-type">{t('labels.new')}</Link>
                        </label>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['projectTypeId'])}</div>
                    <Form.Group inline>
                        <label>{t('labels.upload')}</label>
                        <div className="upload-group">
                            <Button
                                className="btn-upload"
                                content={fileName}
                                labelPosition="right"
                                icon="h"
                                type="button"
                                size="small"
                                onClick={() => this.fileInputRef.current.click()}
                            />
                            <input
                                ref={this.fileInputRef}
                                type="file"
                                hidden
                                onChange={(e) => this.onFileChange(e)}
                                accept=".xlsx, .xls, .xlsm"
                                key={this.state.file}
                            />
                        </div>

                        <label className="new-label">
                            <a onClick={e => { this.linkClick() }} >{t('labels.getStandardFile')}</a>
                        </label>

                    </Form.Group>
                    {
                        (this.state.errImportMsg)
                            ? <div className="error-message form-list-message">{t(this.state.errImportMsg)}</div>
                            : ''
                    }
                    <Form.Group inline>
                        <label>{t('labels.defaultProject')}</label>
                        <Form.Field className="default-project">
                            <input id="default-project" type="checkbox" name="defaultProject" className="invisible"
                                value={projectData.defaultProject}
                                checked={projectData.defaultProject === true ? true : false}
                                onChange={e => { this.handleChangeInput(e) }} />
                            <label htmlFor="default-project" className="checkbox-label no-text">{t('labels.defaultProject')}</label>
                        </Form.Field>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ProjectForm);
